<template>
  <div class="body">
    <Header @ck="onclick($event)"></Header>
    <slideshow></slideshow>
    <div class="content">
      <!-- <div @func="getMsgFormSon"></div> -->
      <div class="content_boxw">
        <div class="content_left">
          <el-tabs :tab-position="tabPosition" v-model="Name">
            <el-tab-pane label="资讯中心" name="1">
              <!-- <News ></News> -->
              <div class="content_right3">
                <div class="Company_box">
                  <p class="Company_text">资讯中心</p>
                  <div class="arrow-right">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }">你现在所在的位置</el-breadcrumb-item>
                      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                      <el-breadcrumb-item>资讯中心</el-breadcrumb-item>
                      <!-- <el-breadcrumb-item>新闻资讯</el-breadcrumb-item> -->
                    </el-breadcrumb>
                  </div>
                </div>

                <div class="news_box1">
                  <!-- <div class="InformationNews">
                    <img src="../../assets/djgz.jpg" alt="" />
                  </div> -->
                  <div class="newsContent">
                    <div class="first">
                      <span>公司新闻</span><span class="genduo" @click="gnduo(2)">更多</span>
                    </div>
                    <div style="display: flex; justify-content: space-between" v-for="(item, index) in list" :key="index"
                      @click="Companynews(item.id, 1, 2)">
                      <p class="first_text">{{ item.title }}</p>
                      <div class="gsxw_a" style="">{{ item.addTime.slice(0, 10) }}</div>
                    </div>
                  </div>
                  <div class="newsContent">
                    <div class="first">
                      <span>公司公告</span><span class="genduo" @click="gnduo(5)">更多</span>
                    </div>
                    <div style="display: flex; justify-content: space-between" v-for="(item, index) in list4" :key="index"
                      @click="Companynews(item.id, 3, 22)">
                      <p class="first_text">{{ item.title }}</p>
                      <div class="gsxw_a" style="">{{ item.addTime.slice(0, 10) }}</div>
                    </div>
                  </div>
                </div>
                <div style="" class="fenlie">
                  <div class="newsContent">
                    <div class="first">
                      <span>行业新闻</span><span class="genduo" @click="gnduo(3)">更多</span>
                    </div>
                    <div style="display: flex; justify-content: space-between" v-for="(item, index) in list2" :key="index"
                      @click="Companynews(item.id, 1, 3)">
                      <p class="first_text">{{ item.title }}</p>
                      <div style="margin-top: 3%">{{ item.addTime.slice(0, 10) }}</div>
                    </div>
                  </div>
                  <div class="newsContent">
                    <div class="first">
                      <span>媒体聚焦</span><span class="genduo" @click="gnduo(4)">更多</span>
                    </div>
                    <div style="display: flex; justify-content: space-between" v-for="(item, index) in list3" :key="index"
                      @click="Companynews(item.id, 3, 24)">
                      <p class="first_text">{{ item.title }}</p>
                      <div style="margin-top: 3%">{{ item.addTime.slice(0, 10) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="公司新闻" name="2">
              <Company></Company>
            </el-tab-pane>
            <el-tab-pane label="公司公告" name="5">
              <Gonggao></Gonggao>
            </el-tab-pane>
            <el-tab-pane label="行业新闻" name="3">
              <Lndustry></Lndustry>
            </el-tab-pane>
            <el-tab-pane label="媒体聚焦" name="4">
              <Media></Media>
            </el-tab-pane>
            <!-- <el-tab-pane label="投资者问答" name="5">
            <Investor></Investor>
          </el-tab-pane> -->
            <!-- <el-tab-pane label="股价走势" name="6">
            <Stocks></Stocks>
          </el-tab-pane> -->
          </el-tabs>
        </div>
      </div>

      <!-- <div v-show="cur == 6" class="content_right4">
        <Stocks></Stocks>
      </div> -->
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "../../components/haed/haed";
import Footer from "../../components/haed/footer";
import News from "../../components/haed/news";
import Lndustry from "../../components/haed/Industry";
import Media from "../../components/media";
import Company from "../../components/haed/company";
import Gonggao from "../../components/haed/gonggao"
// import Company from "../../components/company";
import Investor from "../../components/investor";
import Enterprise from "../../components/enterprise";
import Stocks from "../../components/haed/stocks";
import slideshow from "../../components/haed/slideshow";
import pagination from "../../components/haed/pagination";
import axios from "axios"; //注入
import qs from "qs"; //注入
export default {
  name: "index",
  components: {
    Header,
    Footer,
    News,
    Enterprise,
    Lndustry,
    Media,
    Investor,
    Company,
    Stocks,
    slideshow,
    pagination,
    Gonggao
  },
  data() {
    return {
      cur: 1,
      Name: "1",
      information: [],
      listQuery: {
        bsId: "",
        pageNum: 1,
        pageSize: 3,
      },
      total: 9,
      list: [],
      list2: [],
      list3: [],
      list4: [],
      tabPosition: "left",
      msgFormSon: "this is msg",
    };
  },
  created() {
    this.newsList();
    this.news();
    this.news2();
    this.news3();
    this.news4()
    if (this.$route.query.name) {
      this.Name = this.$route.query.name;
    } else {
    }
  },
  // watch:{
  //   Name(){
  //     console.log(this.Name)
  //      if(this.Name == 4){
  //        console.log()
  //        this.$route.query.page =1
  //      }
  //   }
  // },
  methods: {
    Companynews(id, menu, type) {
      this.$router.push({
        path: "/Companynews?id=" + id + "&menu=" + menu + "&type=" + type + "&rr=" +1,


      });
    },
    gnduo(go) {
      this.Name = go.toPrecision(1);
      console.log(go);
    },
    news: function () {
      this.$axios({
        // method: "post",
        // url: "/index.php/news/newslist",
        // data: qs.stringify({
        //   id: 12,
        //   pageNum: this.listQuery.pageNum,
        //   pageSize: 9,
        // }),
        method: "get",
        url: "/changhang/index/list?menu=1&type=2&pageSize=9&pageNum=1",
        // data: qs.stringify({
        //   id: 12,
        //   pageNum: this.listQuery.pageNum,
        //   pageSize: 9,
        // }),
      })
        .then((res) => {
          
          this.list = res.data.rows;
         
          this.total = res.data.total;
        })
        .catch((res) => { });
    },
    news2: function () {
      this.$axios({
        // method: "post",
        // url: "/index.php/news/newslist",
        // data: qs.stringify({
        //   id: 13,
        //   pageNum: this.listQuery.pageNum,
        //   pageSize: 9,
        // }),
        method: "get",
        url: "/changhang/index/list?menu=1&type=3&pageSize=9&pageNum=1",
      })
        .then((res) => {
          this.list2 = res.data.rows;
          // this.total = res.data.datanum;
        })
        .catch((res) => { });
    },
    news3: function () {
      this.$axios({
        // method: "post",
        // url: "/index.php/news/newslist",
        // data: qs.stringify({
        //   id: 14,
        //   pageNum: this.listQuery.pageNum,
        //   pageSize: 9,
        // }),
        method: "get",
        url: "/changhang/index/list?menu=3&type=24&pageSize=9&pageNum=1",
      })
        .then((res) => {
          this.list3 = res.data.rows;
          // this.total = res.data.datanum;
        })
        .catch((res) => { });
    },
    news4: function () {
      this.$axios({
        // method: "post",
        // url: "/index.php/news/newslist",
        // data: qs.stringify({
        //   id: 21,
        //   pageNum: this.listQuery.pageNum,
        //   pageSize: 9,
        // }),
        method: "get",
        url: "/changhang/index/list?menu=3&type=22&pageSize=9&pageNum=1",
      })
        .then((res) => {
          this.list4 = res.data.rows;
          // this.total = res.data.datanum;
        })
        .catch((res) => { });
    },
    newsList: function (id) {
      this.$axios({
        method: "post",
        data: qs.stringify({
          id: id,
        }),
        url: "/index.php/news/typenews2",
        header: {
          "Content-Type": "application/x-www-form-urlencoded", //post请求设置
        },
      }).then((res) => {
        this.information = res.data.data;
        console.log(res, "================");
      });
    },
    onclick(data) {
      console.log("123", data);
      this.Name = data;
    },
  },
};
</script>
<style scoped>
.gsxw_a {
  margin-top: 2%;
}

.fenlie {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4%;
  margin-top: 5%;
}

.el-pagination {
  width: 96%;
}

.el-breadcrumb {
  font-size: 0.9vw !important;
}

.genduo {
  cursor: pointer;
}

.personne2 {
  height: 1.9vw;
  color: #0b449d;
  font-size: 1.5vw;
  margin: 0 auto;
  /* margin-left: 30%; */
}

.content_right3 {
  /* width: 98%; */
  margin-left: 40px;
}

.enterprise_name {
  font-size: 1.5vw;
  color: #0c47a1;
  text-align: center;
  margin-top: 1vw;
}

.enterprise_box {
  width: 100%;
  height: 17vw;
  margin-top: 1vw;
  display: flex;
  justify-content: space-between;
}

.enterprise_img {
  width: 15vw;
  height: 15vw;
}

.enterprise_img img {
  width: 100%;
  height: 100%;
}

.enterprise_text {
  width: 80%;
  height: 100%;
  font-size: 1.5vw;
}

.Organization_box {
  width: 80%;
  height: 17vw;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.InformationNews {
  width: 350px;
  height: 250px;
}

.InformationNews img {
  width: 100%;
  height: 100%;
}

/* .Organization{
  width: 80%;
  height: 10vw;
  background: darkgreen;
} */
.Organization_img {
  width: 35vw;
  height: 17vw;
  background: url("../../assets/img/gss07.jpg") no-repeat;
  background-size: 100%;
  text-align: center;
  line-height: 18vw;
  font-size: 2vw;
  color: #fff;
}

.Company_box {
  width: 100%;
  height: 2vw;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  border-bottom: 1px solid #dedede;
}

.Company_text {
  font-weight: bold;
  font-size: 32px;
  color: #0c47a1;
  text-align: center;
  line-height: 2vw;
  /* margin-left: 10px; */
  margin-top: -0.5vw;
}

.arrow-right {
  text-align: center;
  margin-top: 0.2vw;
}

.english {
  margin: 0 auto;
  font-size: 1vw;
  text-align: center;
  color: #0b449d;
}

.ys {
  color: #ccc;
}

.Piece {
  width: 10%;
  height: 0.1vw;
  background-color: #0b449d;
  margin: 0 auto;
  margin-top: 10px;
}

.news_box1 {
  width: 100%;
  /* height: 21vw; */
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  /* margin-left: 15%; */
}

.news_img2 {
  width: 40%;
  height: 25vw;
  background: darkgreen;
}

.newsContent {
  width: 46%;
  height: 252px;
  font-size: 16px;
  color: #0b449d;
  overflow: hidden;
}

.first {
  display: flex;
  font-size: 20px;
  color: #76b5ff;
  justify-content: space-between;
}

.first_text {
  margin-top: 10px;
  width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.first_text:hover {
  cursor: pointer;
  color: red;
}

.first_text2 {
  margin-left: 10vw;
  margin-top: 10px;
}

.Pagination_box {
  display: flex;
  width: 40%;
  height: 2vw;
  margin: 0 auto;
  margin-top: 2vw;
}

.Organization_box1 {
  width: 93%;
  display: flex;
  height: 17vw;
  justify-content: space-between;
  margin-top: 20px;
  margin-left: 10px;
  /* background-color: chocolate; */
}

/* 以上是资讯中心 */
.changwz {
  font-size: 16px;
}

.content_boxw {
  width: 1000px;
  margin: auto;
}

.content_right2 {
  width: 77%;
  margin-left: -10%;
}

.content_rigth {
  /* width: 100%; */
  /* margin-left: 20px; */
  /* margin-left: -10%;
  margin-bottom: 2%; */
}

.content_left {
  /* width: 100%; */
}

.content {
  display: flex;
  /* height: 850px; */
  margin-top: 60px;
}

.left {
  width: 20%;
  /* background: blanchedalmond; */
  margin-left: 10px;
}

.el-menu {
  border-right: none;
}

.slash {
  font-size: 0.5vw;
  text-align: center;
  border: 1px solid #cccccc;
  margin: 0 0 -1px -1px;
  height: 1.9vw;
  line-height: 1.9vw;
}

.el-submenu .el-menu-item {
  min-width: 1px;
}

.content_right4 {
  /* width: 98%;
  height: 60vw; */
  width: 77%;
  margin-left: -10%;
}

.content_right2 {
  /* width: 98%; */
  height: 41vw;
  width: 77%;
  margin-left: -10%;
}

.content_right1 {
  /* width: 98%;
  height: 40vw; */
  /* margin-left: 10px; */
  width: 77%;
  margin-left: -10%;
}

.Figure {
  width: 100%;
  height: 30vw;
  margin-top: 20px;
  margin-bottom: 20px;
}

.Figure img {
  width: 100%;
  height: 100%;
  /* margin-top: 20px; */
}

.contentLeft_box {
  display: flex;
  margin-top: 42px;
}

@media screen and (min-width: 320px) and (max-width: 750px) {
  .gsxw_a {
    margin-top: 3%;
  }

  .content {
    margin-top: 20px;
  }

  .el-tabs--left .el-tabs__header.is-left {
    display: none !important;
  }

  /* .newsContent{
   width: 100% !important;
 } */
  .content_boxw {
    width: 100%;
  }

  .content_left {
    margin-left: 0 !important;
  }

  .Company_box {
    display: none;
  }

  .content_right3 {
    margin-left: 5%;
  }

  .InformationNews {
    display: none;
  }

  .news_box1 .newsContent {
    height: 256px;
  }

  .news_box1 {
    width: 198%;
  }

  .fenlie {
    display: block;
  }

  .fenlie .newsContent {
    width: 92%;
  }
}
</style>
<style>
.body .el-submenu__title {
  text-align: center;
  background-color: #0c47a1;
  color: #fff;
}

.el-tabs--left .el-tabs__item.is-left {
  font-size: 24px;
  height: 50px;
}

@media screen and (min-width: 320px) and (max-width: 750px) {
  .body .el-tabs--left .el-tabs__item.is-left {
    display: none !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/index.vue